// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MenuDescription_root__COvyH {
  display: flex;
  align-items: center;
  height: 25px;
  border: 0;
  outline: none;
  background: transparent;
  width: 100%;
  cursor: pointer;
  box-sizing: content-box;
  padding-left: 0;
  padding-right: 0;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
  transition: 0.3s all;
}
.MenuDescription_root__COvyH:first-child {
  padding-top: 10px;
}
.MenuDescription_root__COvyH:last-child {
  padding-bottom: 10px;
}

.MenuDescription_icon__4eO-Y {
  width: 25px;
  height: 25px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding-left: 3px;
}

.MenuDescription_label__SPeHW {
  display: inline-block;
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  color: #8E8E93;
  padding-right: 2px;
  text-decoration: none;
  padding-left: 12px;
}`, "",{"version":3,"sources":["webpack://./../../packages/sdk/src/components/ui/MenuList/MenuDescription/MenuDescription.module.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,mBAAA;EACA,YALO;EAMP,SAAA;EACA,aAAA;EACA,uBAAA;EACA,WAAA;EACA,eAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;KAAA,sBAAA;UAAA,iBAAA;EAUA,oBAAA;AAVF;AAEE;EACE,iBAAA;AAAJ;AAGE;EACE,oBAAA;AADJ;;AAOA;EACE,WA5BO;EA6BP,YA7BO;EA8BP,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;AAJF;;AAOA;EACE,qBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,qBAAA;EACA,kBAAA;AAJF","sourcesContent":["$height: 25px;\n\n.root {\n  display: flex;\n  align-items: center;\n  height: $height;\n  border: 0;\n  outline: none;\n  background: transparent;\n  width: 100%;\n  cursor: pointer;\n  box-sizing: content-box;\n  padding-left: 0;\n  padding-right: 0;\n  user-select: none;\n\n  &:first-child {\n    padding-top: 10px;\n  }\n\n  &:last-child {\n    padding-bottom: 10px;\n  }\n\n  transition: 0.3s all;\n}\n\n.icon {\n  width: $height;\n  height: $height;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding-left: 3px;\n}\n\n.label {\n  display: inline-block;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 14px;\n  color: #8E8E93;\n  padding-right: 2px;\n  text-decoration: none;\n  padding-left: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `MenuDescription_root__COvyH`,
	"icon": `MenuDescription_icon__4eO-Y`,
	"label": `MenuDescription_label__SPeHW`
};
export default ___CSS_LOADER_EXPORT___;
